import { render, staticRenderFns } from "./m_videoworksInfo.vue?vue&type=template&id=f100bcb2&scoped=true&"
import script from "./m_videoworksInfo.vue?vue&type=script&lang=js&"
export * from "./m_videoworksInfo.vue?vue&type=script&lang=js&"
import style0 from "./m_videoworksInfo.vue?vue&type=style&index=0&id=f100bcb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f100bcb2",
  null
  
)

export default component.exports